import styled from "styled-components";

export const Container = styled.div`
  width: 350px;
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  gap: 35px;
`;

export const Heading = styled.h2``;

export const CheeckoutContainer = styled.div`
  background: #f6f5ff;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding: 30px 20px;
`;

export const PriceTotal = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  border-bottom: 1px solid #e8e6f1;
  padding: 10px 0;
`;

export const PriceName = styled.p`
  color: #1d3178;
  font-size: 1.2rem;
  font-weight: 600;
  line-height: 1.5rem;
`;

export const PriceValue = styled.p`
  color: #15245e;
  font-size: 1rem;
  line-height: 1.5rem;
`;

export const CheckoutButton = styled.button`
  width: 100%;
  background-color: #19d16f;
  border-radius: 4px;
  padding: 15px;
  text-transform: capitalize;

  border: 0;
  color: white;
  cursor: pointer;
  transition: background-color 0.3s ease-in-out;
  &:hover {
    background-color: #108245;
  }
`;
